import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Typeahead,
  Menu,
  MenuItem,
  withAsync,
  Highlighter,
} from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Axios from "./../../axios";
import Lodash from "lodash";

import defaultProfileIcon from "./../../assets/images/profile-icon.png";

const AsyncTypeahead = withAsync(Typeahead);

const OrganizationSearch = (props) => {
  const { defaultSelected, multiple = false, handleSelection } = props;

  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const [selectedOrganization, setSelectedOrganization] = useState([]);
  const [query, setQuery] = useState("");
  useEffect(() => {
    if (!defaultSelected) return;
    if (!Lodash.isEqual(defaultSelected, selectedOrganization)) {
      if (Array.isArray(defaultSelected))
        setSelectedOrganization(defaultSelected);
      else setSelectedOrganization([defaultSelected]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSelected]);

  const _innerHandleSelection = (value) => {
    console.log("handleSelection", value);
    if (value.length > 0) {
      if (handleSelection) {
        handleSelection(value[0]);
      }
    }
    setSelectedOrganization(value);
  };

  const onSearch = (query) => {
    setQuery(query);
    setLoading(true);
    Axios.get(`/api/admin/search-organizations-in-mentorstudent?keyword=${query}`)
      .then((res) => {
        //destructure data
        const { items } = res.data;
        // console.log(items, "organization");
        setOptions(items);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error :- ", err);
      });
  };

  return (
    <AsyncTypeahead
      id="my-typeahead-id"
      isLoading={loading}
      labelKey={(option) => {
        return `${option.name || option._source.name}`
      }}
      onSearch={onSearch}
      onChange={_innerHandleSelection}
      placeholder={"Search Organization"}
      searchText="Searching, please wait..."
      useCache={true}
      selected={selectedOrganization}
      options={options}
      multiple={multiple}
      renderMenu={(results, menuProps) => renderMenu(results, menuProps, query)}
      filterBy={() => true}
      delay={200}
    />
  );
};

const renderMenu = (results, menuProps, query = "") => {
  return (
    <Menu {...menuProps}>
      {results &&
        results.map((result, idx) => {
          let name = result._source
            ? result._source.name
            : result.name;
          return (
            <MenuItem key={idx} option={result} position={idx}>
              <img
                alt={defaultProfileIcon}
                src={
                  (result._source && result._source.logoUrl) ||
                  defaultProfileIcon
                }
                style={{
                  height: "50px",
                  marginRight: "10px",
                  width: "50px",
                }}
              />
              <strong key="name">{`${name}`}</strong>
            </MenuItem>
          );
        })}
    </Menu>
  );
};

const handleCustomChildren = (option) => {
  return [
    <>
      <img
        alt={defaultProfileIcon}
        src={
          (option && option.logoUrl) ||
          (option && option._source && option._source.logoUrl) ||
          defaultProfileIcon
        }
        style={{ maxWidth: 50, maxHeight: 50 }}
      />
      <strong key="name">
        {typeof option === "string"
          ? option
          : typeof option === "object" && option._source
          ? option._source.name
          : option.name}
      </strong>
    </>,
  ];
};

export default OrganizationSearch;
